import React, { useState } from 'react';
import { Settings } from '../../pages';
import { userStore } from '../../stores';

const SettingsContainer = () => {
    const [loading, setLoading] = useState(false);
    const [securityModal, setSecurityModal] = useState(false);

    const { user } = userStore;
    const userPermissions = user?.permissions || [];

    const goToSecurity = () => {
        setSecurityModal(true);
    }

    const closeModal = () => {
        setSecurityModal(false);
    }
    return(
        <Settings
        securityModal={securityModal}
        user={user}
        userPermissions={userPermissions}
        goToSecurity={goToSecurity}
        loading={loading}
        closeModal={closeModal}
        />
    )
}
export default SettingsContainer;